// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: syncdownstreamsections.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Section } from "./schema";

export const protobufPackage = "syncdownstreamsections";

export interface SyncDownstreamSectionsRequest {
  /** The section that was modified (e.g., Recommendations) */
  modifiedSection?:
    | Section
    | undefined;
  /** The modification request that was made by the oncologist */
  modificationRequest?:
    | string
    | undefined;
  /** Downstream sections to sync (e.g., Alternatives, Considerations) */
  downstreamSections: Section[];
  /** Case summary for context */
  summary?: string | undefined;
}

export interface SyncDownstreamSectionsResponse {
  /** Updated downstream sections (only those that changed) */
  updatedSections: Section[];
}

function createBaseSyncDownstreamSectionsRequest(): SyncDownstreamSectionsRequest {
  return { modifiedSection: undefined, modificationRequest: undefined, downstreamSections: [], summary: undefined };
}

export const SyncDownstreamSectionsRequest: MessageFns<SyncDownstreamSectionsRequest> = {
  encode(message: SyncDownstreamSectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modifiedSection !== undefined) {
      Section.encode(message.modifiedSection, writer.uint32(10).fork()).join();
    }
    if (message.modificationRequest !== undefined) {
      writer.uint32(18).string(message.modificationRequest);
    }
    for (const v of message.downstreamSections) {
      Section.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.summary !== undefined) {
      writer.uint32(34).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncDownstreamSectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncDownstreamSectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modifiedSection = Section.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modificationRequest = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.downstreamSections.push(Section.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncDownstreamSectionsRequest {
    return {
      modifiedSection: isSet(object.modifiedSection)
        ? Section.fromJSON(object.modifiedSection)
        : isSet(object.modified_section)
        ? Section.fromJSON(object.modified_section)
        : undefined,
      modificationRequest: isSet(object.modificationRequest)
        ? globalThis.String(object.modificationRequest)
        : isSet(object.modification_request)
        ? globalThis.String(object.modification_request)
        : undefined,
      downstreamSections: globalThis.Array.isArray(object?.downstreamSections)
        ? object.downstreamSections.map((e: any) => Section.fromJSON(e))
        : globalThis.Array.isArray(object?.downstream_sections)
        ? object.downstream_sections.map((e: any) => Section.fromJSON(e))
        : [],
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: SyncDownstreamSectionsRequest): unknown {
    const obj: any = {};
    if (message.modifiedSection !== undefined) {
      obj.modifiedSection = Section.toJSON(message.modifiedSection);
    }
    if (message.modificationRequest !== undefined) {
      obj.modificationRequest = message.modificationRequest;
    }
    if (message.downstreamSections?.length) {
      obj.downstreamSections = message.downstreamSections.map((e) => Section.toJSON(e));
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncDownstreamSectionsRequest>, I>>(base?: I): SyncDownstreamSectionsRequest {
    return SyncDownstreamSectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncDownstreamSectionsRequest>, I>>(
    object: I,
  ): SyncDownstreamSectionsRequest {
    const message = createBaseSyncDownstreamSectionsRequest();
    message.modifiedSection = (object.modifiedSection !== undefined && object.modifiedSection !== null)
      ? Section.fromPartial(object.modifiedSection)
      : undefined;
    message.modificationRequest = object.modificationRequest ?? undefined;
    message.downstreamSections = object.downstreamSections?.map((e) => Section.fromPartial(e)) || [];
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseSyncDownstreamSectionsResponse(): SyncDownstreamSectionsResponse {
  return { updatedSections: [] };
}

export const SyncDownstreamSectionsResponse: MessageFns<SyncDownstreamSectionsResponse> = {
  encode(message: SyncDownstreamSectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.updatedSections) {
      Section.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncDownstreamSectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncDownstreamSectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatedSections.push(Section.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncDownstreamSectionsResponse {
    return {
      updatedSections: globalThis.Array.isArray(object?.updatedSections)
        ? object.updatedSections.map((e: any) => Section.fromJSON(e))
        : globalThis.Array.isArray(object?.updated_sections)
        ? object.updated_sections.map((e: any) => Section.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SyncDownstreamSectionsResponse): unknown {
    const obj: any = {};
    if (message.updatedSections?.length) {
      obj.updatedSections = message.updatedSections.map((e) => Section.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncDownstreamSectionsResponse>, I>>(base?: I): SyncDownstreamSectionsResponse {
    return SyncDownstreamSectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncDownstreamSectionsResponse>, I>>(
    object: I,
  ): SyncDownstreamSectionsResponse {
    const message = createBaseSyncDownstreamSectionsResponse();
    message.updatedSections = object.updatedSections?.map((e) => Section.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
